<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router';

const props = defineProps<{
    name: string;
    imageUrl: string;
    route: RouteLocationRaw;
    text: string;
}>();

const imageHref = new URL(props.imageUrl, import.meta.url).href;
</script>

<template>
    <v-col sm="12" md="6" lg="4" xl="3" cols="12">
        <router-link :to="route" class="bg-primary text-decoration-none">
            <div class="module-block-content shadow-xxl rounded-xl position-relative">
                <div class="name rounded-xl bg-alt-light text-main-dark shadow-xl">
                    {{ name }}
                </div>
                <img v-if="imageUrl" :src="imageHref" :alt="name" class="image rounded-t-xl" />
                <p v-if="text" class="px-5 py-4 text-center bg-main-dark text-white text-main-dark rounded-b-xl" style="font-size: 15px">
                    {{ text }}
                </p>
            </div>
        </router-link>
    </v-col>
</template>

<style scoped>
@media (min-width: 1024px) {
    .image {
        height: 600px;
    }
}
.module-block {
    z-index: 0;
}

.module-block-content {
    cursor: pointer;
    padding: 0;
    margin: 30px;

    transition: filter 0.5s;
    &:hover {
        filter: brightness(0.9);
    }
}

.name {
    left: 13%;
    top: -5%;
    width: 75%;
    position: absolute;
    z-index: 5;
    font-weight: bold;
    text-align: center;
    padding: 10px;
    color: var(--vt-c-white);
}
.image {
    width: 100%;
    height: 265px;
}

img {
    overflow: hidden;
    position: relative;
    top: 0;
    z-index: 2;
}
</style>
